module.exports = __webpack_public_path__ + "static/media/orders_icon_active.c2efaa6b.svg";